import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when a user clicks on "About" on the Help page
 * Event: dental_portal:help:about_clicked
 */
export function fireHelpAboutClicked(): void {
  PosthogService.getInstance().track('dental_portal:help:about_clicked');
}
